
import React, {  useState } from "react"
import { Button, Header, Message, Container, Segment, Form, Grid } from 'semantic-ui-react'


import { Link } from "@reach/router";
import { useAuth } from "../contexts/AuthContext"
//import { useHistory } from "react-router-dom"
import {  useNavigate } from "@reach/router";
import "firebase/auth";

function Login() {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth()
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  
  async function handleSubmit(e) {
    e.preventDefault()

    try {
      setError("")
      setLoading(true)
      console.log(email )
      await login(email, password)
      //history.push("/")
      navigate("/")
    } catch {
      setError("Failed to log in")
    }

    setLoading(false)
  }

  return (<Container style={{ padding: 10 }}>
    <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
      <Grid.Column style={{ maxHeigth: 200 }}>
        <div >
          {error !== null && (
            <div style={{ color: "red" }}>
              {error}
            </div>
          )}
        </div>
        
        <div style = {{ background : "#272535", textalign: "center", margin: "auto"}}>

        <p style = {{ background : "#272535", textalign: "center", margin: "auto"}}>
          You are about to participate in discussion with other players. You can choose to post your message in the chat playing an Artificial Agent or a human by clicking on the relative send button. The other players can do the same. There is, however, an actual Artificial Intelligence Agent, and the main goal is to find it. You can click on the buttons near the messages to guess if it is or not an AI. If it was a true AI and you clicked yes, you get 10 points. If another player played an AI role, you get 1 point and -1 point if the part was human. You also add penalties to other players who don't guess your message, so it is worth posting messages in the chat. A leaderboard lists the top players so far, and you can be one of them. Have fun and be polite, of course. 
          </p>
        </div>

        <Header as='h2' color='teal' textAlign='center'>
          Login 
    </Header>
        <Form size='large'>
          <Segment stacked>

            <Form.Input
              type="email"
              style={{ padding: 2 }}
              name="userEmail"
              value={email}
              placeholder="Enter your email"
              id="userEmail"
              onChange={(e) => setEmail(e.target.value)}
            />

            <Form.Input
              type="password"
              style={{ padding: 2 }}
              name="userPassword"
              value={password}
              placeholder="Your Password"
              id="userPassword"
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button color='teal' fluid size='large' disabled={loading}
              onClick={event => {
                handleSubmit(event);
              }}
            >
              Login
        </Button>
          </Segment>
        </Form>
        <Message>
        Don't have an account?
      <Link to="/signUp" >
            Sign up here
        </Link>
        </Message>

      </Grid.Column>
    </Grid>



  </Container>
    
  );
}
export default Login
